import { useState } from 'react';

export default function Gallery() {
  const [activeTab, setActiveTab] = useState('foto');

  const photos = [
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t39.30808-6/459595459_2193249284394902_1275040067226892934_n.jpg?stp=dst-jpg_s160x160_tt6&_nc_cat=102&ccb=1-7&_nc_sid=d8ac62&_nc_ohc=UguSpoIdsLMQ7kNvwEe3DVX&_nc_oc=AdkkqZpiAsfZ9AFcsLdWmMvrYbCt8NjWfegsGZrvndoSTIi0RMUHyOnecGP67vjTHGc&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_Afr4U3Az2KrODqk4W8_G_HY8y3X_XFfdT34FXwuLXtmf3A&oe=697C19B3',
      title: 'Aktiviti Pembelajaran Tahfiz',
      category: 'Pendidikan'
    },
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t39.30808-6/494091729_2390887197964442_5443319537470349568_n.jpg?stp=dst-jpg_s160x160_tt6&_nc_cat=110&ccb=1-7&_nc_sid=e09983&_nc_ohc=BvdENhZdCMcQ7kNvwFSD1wV&_nc_oc=Adm3mtCCwj9mTWcXIh9dYgWmH8KDLdoSqdZDKOLffVF3y9o0wR-3nmx-sM9_Y18RHx0&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_AfpJEZE31TGQ83NMz0F9RU5kSao_4o3R5Tw9aOBNVoICIQ&oe=697C12B9',
      title: 'Majlis Keramaian Madrasah',
      category: 'Majlis'
    },
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t39.30808-6/494130800_2390887277964434_1314155071135480489_n.jpg?stp=dst-jpg_s160x160_tt6&_nc_cat=105&ccb=1-7&_nc_sid=e09983&_nc_ohc=d16ZQBJjuEIQ7kNvwGGxVu5&_nc_oc=AdkZ3qjrXBPzu47FCGeJDR_tfQdgrBqhJ21MR_Po85LSiBk7ZTEnwc3ZzxT943Plyek&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_AfqEbI1njx4MVj5KemFRlSHust6LHgYuZrSmrvwZQtuLCw&oe=697BEBD8',
      title: 'Aktiviti Kokurikulum',
      category: 'Kokurikulum'
    },
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t39.30808-6/493511682_2389141874805641_884389414108022645_n.jpg?stp=dst-jpg_s160x160_tt6&_nc_cat=105&ccb=1-7&_nc_sid=e09983&_nc_ohc=bTL7zg1rTLEQ7kNvwHowNJc&_nc_oc=Adm3EahG2zM92AAm3citvE0LK5zLUwX-LDMOl90a4OBjFtqsZABab2c_Qf-Nel26TNs&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_AfqqnqXWIKBthJ2X7DoJYA43Q95LLm_FRTguK0S544dnPg&oe=697BF788',
      title: 'Program Khidmat Masyarakat',
      category: 'Aktiviti'
    },
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t1.6435-9/52947234_1462365197233703_6265216404111228928_n.jpg?stp=dst-jpg_s160x160_tt6&_nc_cat=108&ccb=1-7&_nc_sid=3b8ee0&_nc_ohc=Edw6MydL34EQ7kNvwGF6fNt&_nc_oc=AdncFoYPS7W6txCjwJ27bJ0z2LogsMox4mIPgrE3KDBpWuqLX2tNwDu45RQdHFtYMME&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_AfpiPbzN_HTbRFotDL5Rg0thp9HnI6hEzaHgOeIUc1ujVg&oe=699D881D',
      title: 'Suasana Pembelajaran',
      category: 'Pendidikan'
    },
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t1.6435-9/33610163_1775809982475684_4962443877093998592_n.jpg?stp=c210.0.540.540a_dst-jpg_s160x160_tt6&_nc_cat=102&ccb=1-7&_nc_sid=8a6525&_nc_ohc=9fEh1Na6630Q7kNvwHHEVvf&_nc_oc=AdlldS1oDQyuuHSXGp-AKqEL2Eh-VULhsp8jS_Kz8jq2hw3xxuaHxak29BQRqZRVdjM&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_Afq8HHkf_4DnEzCxXigqx709WFf3S2FRvx6_DmPMGx07vQ&oe=699D9B66',
      title: 'Aktiviti Madrasah',
      category: 'Fasiliti'
    },
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t1.6435-9/33575466_1775810015809014_4998601986988310528_n.jpg?stp=c210.0.540.540a_dst-jpg_s160x160_tt6&_nc_cat=110&ccb=1-7&_nc_sid=8a6525&_nc_ohc=VKxX2VftOEsQ7kNvwF2h-VD&_nc_oc=Adl9JC1EfjyaXqhr5T79GhxSpIhS8Ckyt2PKYgl_S5Aax4wWlcrinO__s1zChBkL8_4&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_AfpVGKNosSC2rheBw55YKTPQBebq3OuXWuY3Kmk5xUgBTg&oe=699D9325',
      title: 'Program Bersama Pelajar',
      category: 'Kokurikulum'
    },
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t1.6435-9/33522929_1775810072475675_7038746018485108736_n.jpg?stp=c210.0.540.540a_dst-jpg_s160x160_tt6&_nc_cat=101&ccb=1-7&_nc_sid=8a6525&_nc_ohc=wZiqyLNpA-wQ7kNvwHc03tE&_nc_oc=Adm2k_bAMdl_lG__eM1KTnqlT_Dpl3MmRdD7aO1Twbpo9DTLitXoBbHc6Wayk1nvfb4&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_Afopq_SZoSZP4SVDXSPsNFB5tuwT3PjGO2eVOUj2dYSExA&oe=699DADA8',
      title: 'Sesi Pengajian',
      category: 'Majlis'
    },
    {
      url: 'https://scontent-scl3-1.xx.fbcdn.net/v/t1.6435-9/170054338_137153281749150_8756300322296404884_n.jpg?stp=dst-jpg_s160x160_tt6&_nc_cat=108&ccb=1-7&_nc_sid=8a6525&_nc_ohc=7tyyX4kiYeUQ7kNvwEfCdKW&_nc_oc=AdmLG3jGfRT2IyFi2WMV_VmzccK6lvXqHjtz-q7OToeC8VzCGAJjPORDLFBb8uD06hA&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_AfqsU3lxFCMQwbz168a0-ZNFRIpFXLD26-6Skp8kl5OKJA&oe=699DA211',
      title: 'Kegiatan Harian Pelajar',
      category: 'Fasiliti'
    }
  ];

  const videos = [
    {
      thumbnail: 'https://scontent-scl3-1.xx.fbcdn.net/v/t15.5256-10/617735663_1605257517174725_868338331697515084_n.jpg?stp=dst-jpg_s960x960_tt6&_nc_cat=101&ccb=1-7&_nc_sid=5fad0e&_nc_ohc=6a0zppHs9hIQ7kNvwHfG2jk&_nc_oc=AdlRfqoozE1A9lkV6bJdSUqkIEga2RxYDizwZTJtrkiRi3aTE1YqCBOsqx3hFVwxhWU&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=39IE0QzQNU8hh-urdLg4mw&oh=00_AfrC9j9trKff5vuBAHGKF3sNNHHFvkAc23AykFcvQOkESg&oe=697C10BC',
      title: 'Aktiviti Harian Madrasah',
      duration: '1:05',
      link: 'https://www.facebook.com/reel/856973807204300/'
    },
    {
      thumbnail: 'https://static.readdy.ai/image/3294a4af19582454411e375cbd1c78be/2c80b5ad5e6f1a22784856a0f28136eb.jpeg',
      title: 'Video Profil Madrasah 2024',
      duration: '5:30',
      link: 'https://youtube.com/watch?si=l8d-pbsMJI3MufQD&v=BcRXrS6zjbI&feature=youtu.be'
    },
    {
      thumbnail: 'https://static.readdy.ai/image/3294a4af19582454411e375cbd1c78be/29d36ab3de04eb94ee3f1e882d7edff6.png',
      title: 'Tilawah Juara Kebangsaan',
      duration: '3:45',
      link: 'https://youtube.com/shorts/-onr9Mn6D0w?feature=share'
    },
    {
      thumbnail: 'https://scontent-scl3-1.xx.fbcdn.net/v/t39.30808-6/480680960_2325888604464302_8670738997912607949_n.jpg?stp=dst-jpg_s960x960_tt6&_nc_cat=105&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=hubDra2rhTkQ7kNvwHWgsmZ&_nc_oc=AdnJOgz1g7K-a5q2Qz_on8pnHC1N1ciH6AUBhFqra8pdWpc_f0rqYrFt1B1pNJK2eF4&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=B0CtrL3P0xRit4AUIfsSEg&oh=00_Afqjsj6boYTkqehLSe2SnMvP9JKkXrtUde2gMbcDt56DMQ&oe=697C0EC6',
      title: 'Majlis Keramaian 2024',
      duration: '8:20',
      link: ''
    }
  ];

  return (
    <section id="galeri" className="py-20 bg-gradient-to-b from-emerald-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">Galeri</h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Lihat aktiviti dan pencapaian pelajar madrasah kami
          </p>
        </div>

        <div className="flex justify-center gap-4 mb-12">
          <button 
            onClick={() => setActiveTab('foto')}
            className={`px-6 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'foto' 
                ? 'bg-emerald-700 text-white' 
                : 'bg-white text-emerald-700 hover:bg-emerald-50'
            }`}
          >
            <i className="ri-image-line mr-2"></i>
            Foto
          </button>
          <button 
            onClick={() => setActiveTab('video')}
            className={`px-6 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'video' 
                ? 'bg-emerald-700 text-white' 
                : 'bg-white text-emerald-700 hover:bg-emerald-50'
            }`}
          >
            <i className="ri-video-line mr-2"></i>
            Video
          </button>
          <button 
            onClick={() => setActiveTab('alumni')}
            className={`px-6 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'alumni' 
                ? 'bg-emerald-700 text-white' 
                : 'bg-white text-emerald-700 hover:bg-emerald-50'
            }`}
          >
            <i className="ri-user-star-line mr-2"></i>
            Alumni
          </button>
        </div>

        {activeTab === 'foto' && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {photos.map((photo, index) => (
              <div key={index} className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer">
                <img 
                  src={photo.url}
                  alt={photo.title}
                  className="w-full h-72 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="inline-block bg-yellow-500 text-emerald-900 px-3 py-1 rounded-full text-sm font-semibold mb-2">
                      {photo.category}
                    </span>
                    <h3 className="text-white font-bold text-xl">{photo.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'video' && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {videos.map((video, index) => (
              <a 
                key={index} 
                href={video.link || '#'} 
                target={video.link ? '_blank' : '_self'}
                rel={video.link ? 'noopener noreferrer' : ''}
                className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer block"
              >
                <img 
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-72 object-cover object-top"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors flex items-center justify-center">
                  <div className="w-20 h-20 flex items-center justify-center bg-white/90 rounded-full group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-4xl text-emerald-700"></i>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
                  <h3 className="text-white font-bold text-lg mb-2">{video.title}</h3>
                  <div className="flex items-center gap-2 text-white/80 text-sm">
                    <i className="ri-time-line"></i>
                    <span>{video.duration}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        )}

        {activeTab === 'alumni' && (
          <div className="text-center py-20">
            <div className="w-24 h-24 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-6">
              <i className="ri-user-star-line text-4xl text-emerald-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-emerald-900 mb-4">Alumni</h3>
            <p className="text-gray-600 text-lg">
              Maklumat alumni akan dikemas kini tidak lama lagi
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
